import { render } from "./CarteDetailsEnseignant.vue?vue&type=template&id=251d54d8"
import script from "./CarteDetailsEnseignant.vue?vue&type=script&lang=js"
export * from "./CarteDetailsEnseignant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__